const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const base64 = require('base-64');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    Accept: 'application/json'
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    getUserPreferences(metaData) {
      const url = getUrl('get-user-pref-edelivery');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };

      const body = {
        userId: parsedMetaData.qs.userId,
        branchId: parsedMetaData.portfolio.branchCode,
      }

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    },

    saveUserPreferences(preference, screen, metaData) {
      const url = getUrl('save-user-pref-edelivery');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };
      const body = {
        userId: parsedMetaData.qs.userId,
        branchId: parsedMetaData.portfolio.branchCode,
        edelPref: preference.slice(10),
        screen: screen,
      };
      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    }
  };
}

module.exports = apiFactory;
